// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3nAgf","actions":"GroupTable_actions__PS6Ct","deleteModalFooter":"GroupTable_deleteModalFooter__2bQKn"};